import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    max-width: 1280px;
    padding: 0px 100px;
    margin: 21px 0px; 
    @media (max-width: 768px){
        padding: 0px 16px;
        max-width: 100%;
    } 

`; 
export const IconTextConatiner = styled.div`
    display: flex;
    align-items: center;
`;
export const Icon = styled.img`
    width: 24px;
    height: 24px;
`; 
export const Text = styled.p`
    color: #000;
    font-size: 12px;
    font-weight: 400;
`;